// extracted by mini-css-extract-plugin
export default {"root":"wcx0qrM4rzy5t0DiU94K","description":"clTcaxlYnyrg1TvEOdaX","form":"zPjySQq8053nVrkm7wJA","submitButton":"isYg5clR_QKafa4REkFO"};